export default {
    'the-role': "the role",
    "add-new-role": "Add new role",
    "permissions": "permissions",
    "read": "Read",
    "action": "Action",
    "nothing": "Nothing",
    "please-select-a-role": "Please select a role",
    "this-role": "this role"
}